import { GamePlace } from 'constants/cards';
import { comboSoundList } from './Sounds';
import { SoundManager } from './core/soundManager';
import { Store } from './store/gameStore';

//singleton
let foundationStreak = 1;
let lastFoundationHitTime = 0;
const STREAK_RESET_TIME = 3000;

export function moveSound(place: GamePlace, moveType: { autocomplete: boolean; autoPlay: boolean }) {
    const currentTime = performance.now();

    if (place === GamePlace.FOUNDATION && !Store.isSpider) {
        if (moveType.autocomplete) return;
        if (currentTime - lastFoundationHitTime <= STREAK_RESET_TIME) {
            foundationStreak++;
        } else {
            foundationStreak = 1;
        }

        lastFoundationHitTime = currentTime; // Updating timestamp

        // Choose the sound based on the streak
        const soundIndex = (foundationStreak - 1) % comboSoundList.length;
        const soundToPlay = comboSoundList[soundIndex];

        SoundManager.play(soundToPlay);
    }
    if (place === GamePlace.TABLEAU && Store.isSpider) {
        SoundManager.play('cardPutSFX');
    } else if (!Store.isSpider && !moveType.autoPlay && !moveType.autocomplete) {
        SoundManager.play('cardPutSFX');
    }
}
